import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Row } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import { LogoutOutlined } from '@ant-design/icons';
import { useLocalStorageState } from 'ahooks';
import { AccountPersistInfo } from 'Internal.CommonAPI';
import { useLoginUser } from 'Account/hooks/auth';
import { useLogout } from 'Account/hooks/account';
import Alert from 'Common/Components/Alert';
import PinForm from './views/PinForm';

const Title = styled.h2`
  color: #ffffff;
  text-align: center;
  font-family: ${(props) => props.theme.fontFamily};
  margin-bottom: 30px;
`;

const LogoutButton = styled(Button)`
  top: 10px;
  right: 20px;
  font-size: 16px !important;
  position: absolute !important;
  background-color: transparent !important;
  border: none !important;
  color: #fff !important;
  > span {
    margin-left: 5px;
  }
`;

type PinSubmissionProps = {
  pin: string;
};

const Pin: React.FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [account] = useLocalStorageState<AccountPersistInfo>('account');
  const pinLoginMutation = useLoginUser();
  const logoutMutation = useLogout();
  const [hasError, setHasError] = useState(false);

  const navigateToHome = () => {
    navigate('/');
  };

  const navigateToLogin = () => {
    navigate('/login');
    localStorage.removeItem('account');
    localStorage.removeItem('ledger-length');
    localStorage.removeItem('pre-accounting');
  };

  const onPinEnter = ({ pin }: PinSubmissionProps) => {
    pinLoginMutation.mutate(
      {
        username: account?.email as string,
        pin,
        accountToken: account?.accountToken as string,
      },
      {
        onSuccess: ({ token, error }) => {
          if (token) navigateToHome();
          else if (error) {
            setHasError(true);
          }
        },
      }
    );
  };

  const handleLogout = () => {
    logoutMutation.mutate(undefined, {
      onSuccess: () => navigateToLogin(),
    });
  };
  return (
    <>
      <LogoutButton icon={<LogoutOutlined />} onClick={handleLogout}>
        <span>
          <FormattedMessage defaultMessage="Log out" />
        </span>
      </LogoutButton>

      <Title>
        <FormattedMessage defaultMessage="Enter your PIN" />
      </Title>
      {hasError && (
        <Alert
          message={intl.formatMessage({
            defaultMessage:
              'Please try again. You have entered an invalid PIN.',
          })}
          type="error"
        />
      )}
      <Row>
        <PinForm
          checking={pinLoginMutation.isPending}
          email={account?.email as string}
          onPinEnter={onPinEnter}
          error={hasError}
        />
      </Row>
    </>
  );
};

export default Pin;
